import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryProvider } from './providers/QueryProvider';
import { AnalyticsProvider } from './providers/AnalyticsProvider';
import App from './App';
import './index.css';
import { initGA } from './lib/analytics/tracking';

// Initialize Google Analytics
initGA();

// Create root outside of render to avoid recreation
const root = createRoot(document.getElementById('root')!);

// Render app with proper providers
root.render(
  <StrictMode>
    <QueryProvider>
      <BrowserRouter>
        <AnalyticsProvider>
          <App />
        </AnalyticsProvider>
      </BrowserRouter>
    </QueryProvider>
  </StrictMode>
);